import {
  createPluginFactory,
  MARK_FONT_FAMILY,
} from '@udecode/plate';

/**
 * Creates a plugin that adds font family functionality to the editor.
 */
export const createFontFamilyPlugin = createPluginFactory({
  key: MARK_FONT_FAMILY,
  isLeaf: true,
  inject: {
    props: {
      nodeKey: MARK_FONT_FAMILY,
      styleKey: 'fontFamily',
    },
  },
  then: (editor, { type }) => ({
    deserializeHtml: {
      isLeaf: true,
      getNode: (el) => {
        const { style } = el;
        const { fontFamily } = style;

        // Split fonts and fallbacks.
        const fontsArr = fontFamily.split(',');

        // Only get the first font if multiple fonts used as fallback.
        let font = fontsArr.length > 0 ? fontsArr[0] : null;
        if (font) {
          // Normalize font value.
          // 1. Remove quotes, if any.
          font = font.replaceAll('"', '');
          // 2. Capitalize first letter of each word.
          font = font.replace(/\b\w/g, letter => letter.toUpperCase());
          return { [type]: font };
        }
      },
      rules: [
        {
          validStyle: {
            fontFamily: '*',
          },
        },
      ],
    },
  }),
});

export const GOOGLE_FONT_LINK_ID = 'ap-wysiwyg-editor-font-families';

export const getGoogleFonts = () => {
  // eslint-disable-next-line
  const fontLink = 'https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;700&family=Dancing+Script:wght@400;700&family=EB+Garamond:ital,wght@0,400;0,700;1,400;1,700&family=Lexend:wght@400;700&family=Roboto:ital,wght@0,400;0,700;1,400;1,700&family=Spectral:ital,wght@0,400;0,700;1,400;1,700&family=Syncopate:wght@400;700&display=swap';
  const gfontLink = document.createElement('link');
  gfontLink.href = fontLink;
  gfontLink.rel = 'stylesheet';
  gfontLink.id = GOOGLE_FONT_LINK_ID;
  document.head.append(gfontLink);
};
